import { LiquidateTypesRRHH } from "types/liquidateRRHH"
import { useTranslation } from "utils/translation/Translation"
import { HistoricalsLiquidateSystemTypes } from '../../types/liquidateSystemTypes/LiquidateSystemTypes';
import { LiquidateKamTypes } from "types/LiquidateKAM";

interface Props {
  data: LiquidateTypesRRHH | HistoricalsLiquidateSystemTypes | LiquidateKamTypes
}




export const CocatenationTitle = ({data}: Props) => {

  const translation = useTranslation()

 const isMonthAndYear = data.paymentMonth && data.paymentYear

 const newTitle = `${data.isExtraordinary ? `${translation('LIQUIDATE.COL')} ${translation('EXTRAORDANRY')} ${translation(data.paymentMonth)} - ${translation('CLOSEDATE')} ${translation(data.cutoffMonth)} ${data.cutoffYear}` : ''}`

 const string = `${isMonthAndYear ? `${translation('LIQUIDATE.COL')} ${translation(data.paymentMonth)} -` : ''} ${data.cutoffMonth && data.cutoffYear ? `${translation('CLOSEDATE')} ${translation(data.cutoffMonth)} ${data.cutoffYear}` : ''} `


  return (
    <>{newTitle || string}</>
  )
}
